import { render, staticRenderFns } from "./TimeClocks.vue?vue&type=template&id=d1068e4a"
import script from "./TimeClocks.vue?vue&type=script&lang=js"
export * from "./TimeClocks.vue?vue&type=script&lang=js"
import style0 from "./TimeClocks.vue?vue&type=style&index=0&id=d1068e4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports